"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const Box_1 = require("../Box");
const ForwardRefHOC_1 = __importDefault(require("../ForwardRefHOC"));
const Typography_1 = require("../Typography");
const Tooltip = (props) => {
    const { className, placement = 'bottom', arrowAlignment = 'center', isVisibleForAnimation, forwardedRef } = props;
    const placementClass = placement ? placement : 'top';
    const arrowAlignmentClass = arrowAlignment && (placement === 'top' || placement === 'bottom')
        ? `align-${arrowAlignment}`
        : '';
    const hasRunAnimateIn = react_1.useRef(false);
    if (isVisibleForAnimation === true) {
        hasRunAnimateIn.current = true;
    }
    const finalClassName = classnames_1.default(className, placementClass, arrowAlignmentClass, {
        'animate-initial-state': hasRunAnimateIn.current === false &&
            isVisibleForAnimation !== undefined,
        'animate-in': isVisibleForAnimation,
        'animate-out': hasRunAnimateIn.current && isVisibleForAnimation === false
    });
    return (react_1.default.createElement(Box_1.Box, { position: 'relative', forwardedRef: forwardedRef },
        props.children,
        react_1.default.createElement(Box_1.Box, { id: 'tooltip', className: finalClassName, elevation: 1, position: 'absolute', borderRadius: 'xs' },
            react_1.default.createElement(Box_1.Box, { className: 'tooltip-arrow', elevation: 1, background: 'information' }),
            react_1.default.createElement(Box_1.Box, { className: 'tooltip-inner', padding: 'sm', background: 'information', color: 'white', borderRadius: 'xs' },
                react_1.default.createElement(Typography_1.Typography, { className: 'tooltip-inner-text', type: 'paragraph-xs', as: 'span' }, props.bodyText)))));
};
exports.Tooltip = Tooltip;
exports.Tooltip.displayName = 'Tooltip';
exports.default = ForwardRefHOC_1.default(exports.Tooltip);
